import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { track, EVENTS } from '../../utils/analyticsService';

import { NavBar } from "../../commonComponents";
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import styles from "../Marketplace/Marketplace.module.css";
import FleekIcon from "../../asset/icons/FleekIcon.png";
import NoSearchResult from "../../asset/images/NoSearchResult.png";

import { useParams } from "react-router-dom"; 

import {
  MarketPlaceCard,
  BundleMarketCard,
  SearchComp,
} from "../../components";
import { SectionCard } from "../../components/SectionCard/SectionCard";
import Api from "../../utils/Api/Api";
import InfiniteScroll from "react-infinite-scroll-component";


import Helper from "../../utils/Helper";

export const PartnershipBanner = ({ partnershipData }) => {
  // If there's no partnershipData, don't render anything
  if (!partnershipData) {
    return null;
  }

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      justifyContent: "center", 
      alignItems: "center", 
      gap: "10px",
      margin: "20px 0"
    }}>
      <p style={{ 
        fontSize: "18px", 
        fontWeight: "bold", 
        margin: 0, 
        color: "#FFFFFF"
      }}>
        Partnership with {partnershipData?.name}
      </p>
      <img 
        src={partnershipData?.logoUrl} 
        alt={`${partnershipData?.name} Logo`} 
        style={{ 
          maxWidth: "150px", 
          width: "100%", 
          height: "auto" 
        }} 
      />
    </div>
  );
};

export const MarketplaceUniquePlans = ({ isLoggedIn }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [hasError, setError] = useState(false);
  const [bundleData, setBundleData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const isMobile = Helper.isMobile();
  const [showMobileSearch, setShowMobileSerach] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [partnershipData, setPartnershipData] = useState(null);
  
  // Sections state (same as Marketplace.js)
  const [sectionsList, setSectionsList] = useState([]);
  const [sectionsData, setSectionsData] = useState({});
  const [sectionsLoading, setSectionsLoading] = useState({});
  

  const { keyword } = useParams();

  const toggleMobSearch = () => {
    setShowMobileSerach((pre_state) => !pre_state);
  };
  
  const fetchMarketPlaceData = async (page_size = 100, searchFlow, keyword) => {
    try {
      const promiseArr = [
        Api.MarketPlaceData({
          service_name: searchValue ? searchValue : undefined,
          page: !searchFlow ? page : 1,
          digital_only: 1,
          page_size,
          ua: keyword ? keyword : undefined
        }),
      ];
      if (page === 1 && !searchFlow) {
        promiseArr.push(Api.MarketPlaceBundle({ os: "web" }));
      }
      const [{ data }, bundle] = await Promise.all(promiseArr);

      // Banner code commented out
      // if (
      //   banner &&
      //   banner.data &&
      //   banner.data.Marketplace &&
      //   banner.data.Marketplace.length
      // ) {
      //   let bannerImages = banner.data.Marketplace.map((b) => {
      //     return {
      //       web_banner_url: !isMobile ? b.web_banner_url : b.banner_url,
      //       vendor_web_path: b.vendor_web_path,
      //       deep_link_url: b.deep_link_url,
      //     };
      //   });
      //   bannerImages = bannerImages.filter(
      //     (ele) => ele.web_banner_url !== null
      //   );
      //   setBrandImage(bannerImages);
      // }
      console.log("data", data);
      if(data.results[0].partnership_logo_url && data.results[0].partnership_name){
        setPartnershipData({
          logoUrl: data.results[0].partnership_logo_url,
          name: data.results[0].partnership_name
        })
      }
      if (bundle?.data) {
        setBundleData(bundle.data);
      }
      if (data && data.results && data.results.length) {
        let newBrandData;
        if (!searchFlow) {
          newBrandData = [...brandData, ...data.results];
          setBrandData(newBrandData);
          if (!data.next) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          setPage(page + 1);
        } else {
          if (!data.next) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          newBrandData = [...data.results];
          setBrandData(newBrandData);
        }
      } else {
        if (!data?.next) {
          setHasMore(false);
        }
        setBrandData([]);
      }
    } catch (err) {
      console.log("=======err==========", err);
      setError(true);
    }
    setLoading(false);
  };
  
  const ExploreMarketPlace = () => {
    setSearchValue("");
    if (isMobile) {
      toggleMobSearch();
    }
  };
  
  useEffect(() => {
    track(EVENTS.CATALOGUE_VIEWED, { category: keyword || null, context: "uniquely_available_plans" });
    // Fetch marketplace data with keyword from URL params
    fetchMarketPlaceData(100, false, keyword);
    // Fetch sections data with keyword parameter
    fetchSections(keyword);
  }, [keyword]); // Added keyword to dependencies for proper behavior

  const bundleView = () => {
    return bundleData.map((b) => {
      return (
        <div key={b.id}>
          <BundleMarketCard
            plan={{
              planName: b.name,
              mrp_price: b.mrp_price,
              category: b.new_discount_percentage,
              max_coin_usable: b.max_coin_usable,
              discounted_cost: b.discounted_cost,
              image: b.plan_images_list,
              id: b.id,
              color: b.details?.colour_code,
              bundle_web_path: b.bundle_web_path,
            }}
          />
        </div>
      );
    });
  };
  
  useEffect(() => {
    fetchMarketPlaceData(100, "search", keyword);
  }, [searchValue]);



  // Sections functions (same as Marketplace.js)
  const fetchSections = async (keyword) => {
    try {
      let data;
      if (keyword) {
        // Call custom API endpoint with ua parameter
        const response = await Api.GetSectionsList({ ua: keyword });
        data = response.data;
      } else {
        // Use the regular API method
        const response = await Api.GetSectionsList();
        data = response.data;
      }
      
      if (data) {
        // Sort sections by order_of_display
        const sortedSections = data.sort((a, b) => a.order_of_display - b.order_of_display);
        setSectionsList(sortedSections.filter(section => section.is_active));
        
        // Fetch data for each section
        sortedSections.forEach(section => {
          fetchSectionData(section.id, keyword);
        });
      }
    } catch (err) {
      console.error("Error fetching sections:", err);
    }
  };

  const fetchSectionData = async (sectionId, keyword) => {
    try {
      setSectionsLoading(prev => ({ ...prev, [sectionId]: true }));
      const params = { section_id: sectionId, os: 'web' };
      if (keyword) {
        params.ua = keyword;
      }
      const { data } = await Api.GetSectionData(params);
      if (data) {
        setSectionsData(prev => ({
          ...prev,
          [sectionId]: data
        }));
      }
    } catch (err) {
      console.error(`Error fetching section ${sectionId} data:`, err);
    } finally {
      setSectionsLoading(prev => ({ ...prev, [sectionId]: false }));
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const renderSectionSkeleton = () => {
    return (
      <div className={styles.sectionSkeleton}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, idx) => (
          <div key={idx} className={styles.logoSkeletonCard}>
            <div className={styles.logoSkeletonWrapper}></div>
            <div className={styles.logoSkeletonText}></div>
            <div className={styles.logoSkeletonPrice}></div>
          </div>
        ))}
      </div>
    );
  };

  const renderSection = (sectionId) => {
    const sectionData = sectionsData[sectionId];
    const sectionDetails = sectionsList.find(s => s.id === sectionId);
    const isLoading = sectionsLoading[sectionId];
    
    if (!sectionDetails) return null;
    
    // Check if there's data to show in the section
    if (!isLoading && (!sectionData || sectionData.length === 0)) {
      return null; // Don't render the section if there's no data
    }
    
    return (
      <div key={sectionId} className={styles.sectionWrapper}>
        <div className={styles.BundleExploreContainer}>
          <p className={styles.sectionTitle}>{sectionDetails.name}</p>
          {sectionDetails.see_all_cta && sectionDetails.cta_text && (
            <p 
              onClick={() => handleNavigation(sectionDetails.deeplink_url || '/')} 
              className={styles.sectionSeeAll}
            >
              {sectionDetails.cta_text || 'SEE ALL'}
            </p>
          )}
        </div>
        {sectionDetails.subheading && (
          <p className={styles.sectionSubTitle}>{sectionDetails.subheading}</p>
        )}
        
        {isLoading ? (
          renderSectionSkeleton()
        ) : (
          <div className={styles.sectionScrollContainer}>
            {sectionData?.map((item, index) => (
              <SectionCard 
                key={`${item.vendor.vendor_id}-${index}`} 
                data={item.vendor} 
              />
            ))}
          </div>
        )}
      </div>
    );
  };



  if (hasError) {
    return <ErrorFallback />;
  }
  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.marketplace}>
      {isMobile && <NavBar fixedNavBar={true} isLoggedIn={isLoggedIn} />}

      {/* Banner section commented out */}
      {/* <div className={styles.headcontent}>
        <div className={styles.sliderWrapper}>
          {brandImage && brandImage.length ? (
            <Slider ref={sliderRef} {...settings}>
              {brandImage.map((ele, idx) => (
                <a
                  href={
                    ele.deep_link_url
                      ? ele.deep_link_url
                      : `/brand/${ele.vendor_web_path}`
                  }
                  target={ele.deep_link_url ? "_blank" : ""}
                  onClick={() => {
                    if (ele.deep_link_url) {
                      // If deep_link_url exists, prevent the default behavior of the link
                      // to prevent the page from navigating twice (once with window.open and once with navigate)
                      window.open(ele.deep_link_url, "_blank");
                    } else if (ele.vendor_web_path) {
                      // If deep_link_url doesn't exist but vendor_web_path exists, use navigate
                      navigate(`/brand/${ele.vendor_web_path}`);
                    }
                  }}
                >
                  <img
                    key={idx}
                    className={styles.bannerImage}
                    alt="bannerImage"
                    src={ele.web_banner_url}
                  />
                </a>
              ))}
            </Slider>
          ) : (
            ""
          )}
        </div>
        <div className={styles.dotContainer}>
          {brandImage.map((_, idx) => (
            <div
              key={idx}
              onClick={() => {
                setSlideNumbar(idx);
              }}
              className={
                idx === slideNumber ? cx(styles.dot, styles.active) : styles.dot
              }
            ></div>
          ))}
        </div>
      </div> */}
      {/* <div className={styles.restContent}>
                
            </div> */}
      <div className={styles.restContent}>
        {/* <div className={styles.BundleExploreContainer}>
          <p className={styles.sectionTitle}>Exclusive bundles on Fleek 🤑</p>
          <p
            onClick={() => navigate("/bundle")}
            className={styles.sectionSeeAll}
          >
            SEE ALL
          </p>
        </div> */}
        {/* Write Code Here with center heading - exclusive bundles on Fleek 🤑 */}
        <p className={styles.sectionTitle} style={{ textAlign: "center", fontSize: "20px" }}>Exclusive Offers on Fleek 🤑</p>

        <div>
        <PartnershipBanner partnershipData={partnershipData} />
        </div>

        <div className={styles.bundleGrid}>
          {bundleView()}
        </div>

        {/* Render dynamic sections */}
        {sectionsList.map(section => renderSection(section.id))}

        {/* All Brands Section */}
        <div className={styles.tempSearchContainer}>
          <p className={styles.sectionTitle}>Explore all brands</p>
        </div>

        <InfiniteScroll
          dataLength={brandData.length}
          next={fetchMarketPlaceData}
          hasMore={hasMore}
          endMessage={<p style={{ textAlign: "center" }}></p>}
          refreshFunction={() => brandData}
          pullDownToRefresh
          pullDownToRefreshThreshold={20}
        >
          <div
            className={
              brandData.length ? styles.cardContainer : styles.noResultContainer
            }
          >
            {brandData.length ? (
              brandData.map((d) => {
                return (
                  <div key={d.vendor_id}>
                    <MarketPlaceCard data={d} />
                  </div>
                );
              })
            ) : (
              <div className={styles.container1}>
                <img
                  src={NoSearchResult}
                  alt="NoSearchResult"
                  className={styles.NoSearchResult}
                />
                <p className={styles.noResult}>No results found!</p>
                <button onClick={ExploreMarketPlace} className={styles.button1}>
                  EXPLORE MARKETPLACE
                </button>
              </div>
            )}
          </div>
        </InfiniteScroll>
      </div>
      <div className={styles.spacer}></div>
      {/* <MobileBottomNavBar isLoggedIn={isLoggedIn} type={"marketPlace"} /> */}
    </div>
  );
};